import { Component, HostListener, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  dropdownStates = [false, false, false, false, false, false, false, false, false, false]; // About, Admission, Academics, Student's Life, Infrastructure, Faculty, Transport, Committee, Sports, Others
  isMobileScreen = false;
  subDropdownStates: { [key: number]: boolean } = {};

  isHomePage = false; // <-- for showing / hiding side-quick-links & Apply Now
  isStickyActive = false;

  isVideoActive = false;
  private modalEl: HTMLElement | null = null;
  private hideListener: (() => void) | null = null;

  // Cached DOM elements for scroll optimization
  private bringToTopEl: HTMLElement | null = null;
  private headerEl: HTMLElement | null = null;
  private header1El: HTMLElement | null = null;

  constructor(private router: Router, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.so = null; // compatibility placeholder if any
    this.checkScreenSize();

    // detect home page
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        // add '/home' if you also use that as home route
        this.isHomePage = (url === '/' || url === '/home');
      });
  }

  private initScrollElements(): void {
    if (!this.bringToTopEl) this.bringToTopEl = document.getElementById('bring-top');
    if (!this.headerEl) this.headerEl = document.getElementById('header');
    if (!this.header1El) this.header1El = document.getElementById('header1');
  }

  private so: any;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.initScrollElements();

    if (!this.headerEl || !this.header1El) return;

    // Back-to-top button
    if (this.bringToTopEl) {
      this.bringToTopEl.classList.toggle('d-none', window.scrollY < 50);
    }

    // Mobile/Tablet only - disable sticky header
    if (window.innerWidth < 992) {
      if (this.isStickyActive) {
        this.headerEl.style.display = 'block';
        this.header1El.style.display = 'none';
        this.isStickyActive = false;
      }
      return;
    }

    // Desktop sticky header logic (992px and above)
    const scrollThreshold = this.getScrollThreshold();

    // Activate sticky
    if (window.scrollY >= scrollThreshold && !this.isStickyActive) {
      this.headerEl.style.display = 'none';
      this.header1El.style.display = 'block';
      this.isStickyActive = true;
    }

    // Deactivate sticky
    if (window.scrollY < scrollThreshold && this.isStickyActive) {
      this.header1El.style.display = 'none';
      this.headerEl.style.display = 'block';
      this.isStickyActive = false;
    }
  }

  /**
   * Get scroll threshold based on screen size
   * Medium laptops need earlier trigger due to header size
   */
  private getScrollThreshold(): number {
    const width = window.innerWidth;

    if (width >= 1500) {
      return 110; // Large screens - standard threshold
    } else if (width >= 1200) {
      return 90; // Medium laptops - trigger earlier
    } else if (width >= 992) {
      return 80; // Smaller desktops - trigger even earlier
    }

    return 110; // Default
  }

  @HostListener('window:resize')
  checkScreenSize() {
    this.isMobileScreen = window.innerWidth <= 991; // Match Bootstrap's lg breakpoint

    // Reset sticky header on resize to prevent stuck states
    if (this.isMobileScreen && this.isStickyActive) {
      const header = document.getElementById('header');
      const header1 = document.getElementById('header1');

      if (header && header1) {
        header.style.display = 'block';
        header1.style.display = 'none';
        this.isStickyActive = false;
      }
    }

    // Close all dropdowns on resize to prevent layout issues
    this.dropdownStates = this.dropdownStates.map(() => false);
  }

  toggleDropdown(index: number, open: boolean) {
    if (this.isMobileScreen) {
      // Toggle on click for mobile
      this.dropdownStates[index] = !this.dropdownStates[index];
    } else {
      // Toggle on hover for desktop
      this.dropdownStates[index] = open;
    }
  }

  toggleSubmenu(index: number, state: boolean) {
    this.subDropdownStates[index] = state;
  }

  // Close dropdown on item selection
  closeDropdown(index: number) {
    this.dropdownStates[index] = false;
  }

  openUrl(id: string) {
    window.open(id, '_blank');
  }

  bringToTop() {
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  ngAfterViewInit(): void {
    // Listen to header modal close event to stop the video iframe
    this.modalEl = document.getElementById('headerTourModal');
    if (this.modalEl) {
      this.hideListener = () => {
        this.isVideoActive = false;
        this.cdr.detectChanges();
      };
      this.modalEl.addEventListener('hide.bs.modal', this.hideListener);
    }
  }

  openVideo(): void {
    this.isVideoActive = true;
  }

  ngOnDestroy(): void {
    if (this.modalEl && this.hideListener) {
      this.modalEl.removeEventListener('hide.bs.modal', this.hideListener);
    }
  }
}